export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const quickLinks = [
    { label: 'About', id: 'about' },
    { label: 'Contributors', id: 'contributors' },
    { label: 'Services', id: 'services' },
    { label: 'Products', id: 'products' },
    { label: 'Events', id: 'events' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <footer className="bg-matou-teal-dark border-t border-white/10">
      <div className="max-w-content mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-xl font-bold text-white mb-3">
              Mātou Collective
            </h3>
            <p className="font-mono text-sm text-white/60 leading-relaxed max-w-sm">
              Indigenous-led collective building open-source digital infrastructure
              and tooling for community self-determination.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-mono text-xs font-semibold text-white/40 uppercase tracking-widest mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="font-mono text-sm text-white/60 hover:text-matou-teal-soft transition-colors duration-150"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
              <li>
                <a
                  href="https://docs.matou.nz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-mono text-sm text-white/60 hover:text-matou-teal-soft transition-colors duration-150"
                >
                  Docs
                </a>
              </li>
              <li>
                <a
                  href="https://matou.nz/downloads"
                  className="font-mono text-sm text-white/60 hover:text-matou-teal-soft transition-colors duration-150"
                >
                  Downloads
                </a>
              </li>
            </ul>
          </div>

          {/* Follow Our Journey */}
          <div>
            <h4 className="font-mono text-xs font-semibold text-white/40 uppercase tracking-widest mb-4">
              Follow Our Journey
            </h4>
            <div className="flex flex-col gap-3">
              <a
                href="https://x.com/MatouCollective"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/60 hover:text-matou-teal-soft transition-colors duration-150"
              >
                <svg className="w-4 h-4 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
                <span className="font-mono text-sm">Twitter</span>
              </a>
              <a
                href="https://www.linkedin.com/company/m%C4%81tou-collective/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/60 hover:text-matou-teal-soft transition-colors duration-150"
              >
                <svg className="w-4 h-4 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
                <span className="font-mono text-sm">LinkedIn</span>
              </a>
              <a
                href="https://gitlab.com/matou-collective"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/60 hover:text-matou-teal-soft transition-colors duration-150"
              >
                <svg className="w-4 h-4 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.955 13.587l-1.342-4.135-2.664-8.189a.455.455 0 00-.867 0L16.418 9.45H7.582L4.918 1.263a.455.455 0 00-.867 0L1.386 9.45.044 13.587a.924.924 0 00.331 1.023L12 23.054l11.625-8.443a.92.92 0 00.33-1.024" />
                </svg>
                <span className="font-mono text-sm">GitLab</span>
              </a>
            </div>

            <div className="mt-6">
              <a
                href="mailto:info@matou.nz"
                className="font-mono text-sm text-white/60 hover:text-matou-teal-soft transition-colors duration-150"
              >
                info@matou.nz
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 mt-10 pt-6">
          <p className="font-mono text-xs text-white/40 text-center">
            &copy; {currentYear} Mātou Collective. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
